import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './TourDetails.css';

const TourDetails = () => {
  const { id } = useParams();
  const [tour, setTour] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchTour = async () => {
      try {
        setLoading(true);
        const res = await fetch(`/api/tour/${id}`);
        if (!res.ok) throw new Error('Tour not found');
        const data = await res.json();
        setTour(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchTour();
  }, [id]);

  if (loading) return <div className="tour-details-loading">Loading...</div>;
  if (error) return <div className="tour-details-error">{error}</div>;
  if (!tour) return null;

  return (
    <div className="tour-details-container">
      <h2 className="tour-details-title">{tour.name}</h2>
      <img className="tour-details-image" src={tour.image} alt={tour.name} />
      <div className="tour-details-meta">
        <span>{tour.days - 1}N/{tour.days}D</span>
        <span>Price: Rs.{tour.price}</span>
        {tour.discount && tour.discount > 0 && (
          <span className="tour-details-discount">{tour.discount}% OFF</span>
        )}
      </div>
      <div className="tour-details-section">
        <h3>Description</h3>
        <p>{tour.description}</p>
      </div>
      {tour.features && tour.features.length > 0 && (
        <div className="tour-details-section">
          <h3>Features</h3>
          <ul>
            {tour.features.map((f, i) => <li key={i}>{f}</li>)}
          </ul>
        </div>
      )}
      {tour.amenities && tour.amenities.length > 0 && (
        <div className="tour-details-section">
          <h3>Amenities</h3>
          <ul>
            {tour.amenities.map((a, i) => <li key={i}>{a}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
};

export default TourDetails;
